import {Autocomplete, MenuItem, Select, Stack, TextField} from "@mui/material";
import {useState, useEffect} from "react";
import Modal from "../ui/Modal";
import FormItem from "../ui/FormItem";
import {DatePicker} from "../ui/DateTimePickers";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {createAdmissionEvent, createFee, getAllInstitutions} from "../../api";
import {useSnackbar} from "notistack";

const AddEvent = ({data, isEdit, ...props}) => {
  const [institutions, setInstitutions] = useState([]);
  const {enqueueSnackbar} = useSnackbar();
  const [loading, setLoading] = useState(false);
  //   const [inputValue, setInputValue] = useState("")
  //   const [students, setStudents] = useState([])
  const [eventDetails, setEventDetails] = useState({
    name: "",
    code: "",
    institutionId: "",
    academicYear: "",
    admissionDate: dayjs(),
  });

  const handleChange = (event) => {
    const {name, value} = event.target;
    setEventDetails({
      ...eventDetails,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    setLoading(true);
    createAdmissionEvent(eventDetails)
      .then((res) => {
        enqueueSnackbar("Admission event added.", {variant: "success"});
        // console.log(res.data)
        // props.refresh()
        props.close();
      })
      .catch((err) => enqueueSnackbar(err.data, {variant: "error"}))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setEventDetails(
      data || {
        name: "",
        code: "",
        institutionId: "",
        academicYear: "",
        admissionDate: dayjs(),
      }
    );
  }, [data]);

  const fetchInstitutions = () => {
    getAllInstitutions()
      .then((res) => {
        setInstitutions(res.data.rows);
        setEventDetails({
          ...eventDetails,
          institutionId: res.data.rows.length ? res.data.rows[0].id : "",
        });
      })
      .catch((err) =>
        enqueueSnackbar("Something went wrong", {variant: "error"})
      );
  };

  useEffect(() => {
    fetchInstitutions();
  }, []);

  //   const searchStudents = (value) => {
  //     findStudents(value)
  //       .then((res) =>
  //         setStudents(res.data.rows.map((r) => ({ ...r, label: r.name })))
  //       )
  //       .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
  //   }

  return (
    <Modal
      {...props}
      title={isEdit ? "Edit Event" : "Add Event"}
      actionText={isEdit ? "Edit" : "Add"}
      action={handleSubmit}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Name">
            <TextField
                name="name"
                value={eventDetails.name}
                onChange={handleChange}
              />
            </FormItem>
            <FormItem label="Code">
              <TextField
                name="code"
                value={eventDetails.code}
                onChange={handleChange}
              />
            </FormItem>
          </Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Institution">
              <Select
                name="institutionId"
                value={eventDetails.institutionId}
                onChange={handleChange}
              >
                {institutions.map((institution) => (
                  <MenuItem key={institution.id} value={institution.id}>{institution.name}</MenuItem>
                ))}
              </Select>
            </FormItem>
            <FormItem label="Academic Year">
              <TextField
                name="academicYear"
                value={eventDetails.academicYear}
                onChange={handleChange}
              />
            </FormItem>
          </Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Admission date">
              <DatePicker
                value={eventDetails.admissionDate}
                onChange={(date) =>
                  setEventDetails({
                    ...eventDetails,
                    admissionDate: date,
                  })
                }
              />
            </FormItem>
            {/* <FormItem label="Ending date">
              <DatePicker
                value={eventDetails.toDate}
                onChange={(date) =>
                  setEventDetails({
                    ...eventDetails,
                    toDate: date,
                  })
                }
              />
            </FormItem> */}
            {/* <FormItem label="Payer">
              <Autocomplete
                value={feeDetails.payer}
                onChange={(_, newValue) => {
                  setFeeDetails({
                    ...feeDetails,
                    payer: newValue,
                  })
                }}
                inputValue={inputValue}
                onInputChange={(_, newInputValue) => {
                  setInputValue(newInputValue)
                  searchStudents(newInputValue)
                }}
                getOptionLabel={(option) => option.label}
                options={students}
                renderInput={(params) => <TextField {...params} />}
              />
            </FormItem> */}
          </Stack>
        </Stack>
      </LocalizationProvider>
    </Modal>
  );
};

export default AddEvent;
